import { regStepIds } from './eventConstants';
import EventTours from './EventTours';
import { linkedAccountTypes } from './oauth';

export const AO_1_POINT_SLAM_TA_LINK_PENDING_KEY = 'ao1PointSlamTaLinkPending';

export const tennisAustraliaLinkSuccessToast = {
    title: 'Account Successfully Linked',
    message: 'Your UTR profile & TA Tennis ID account have been linked.',
};

export const isAo1PointSlamEvent = (event) => {
    if (event?.isAo1PointSlamEvent) {
        return true;
    }
    return Boolean(event?.eventTours?.some((tour) => tour?.id === EventTours.Ao1PointSlam));
};

export const hasTennisAustraliaLinkedAccount = (linkedAccountsData) => {
    const accounts = linkedAccountsData?.memberThirdPartyAccounts;
    if (!Array.isArray(accounts)) {
        return false;
    }
    return accounts.some((account) => account?.type === linkedAccountTypes.TENNIS_AUSTRALIA);
};

export const shouldGateAo1PointSlamRegistration = ({ event, isGateEnabled, hasLinkedTennisAustraliaAccount }) => {
    return isAo1PointSlamEvent(event) && Boolean(isGateEnabled) && !hasLinkedTennisAustraliaAccount;
};

// The gate controls who joins an AO 1 Point Slam event, not who leaves one. A player added by
// the organizer never had to link an account, so requiring one to withdraw would strand them.
const tennisAustraliaGateExemptFlows = [regStepIds.DIVISIONS_CANCEL];

export const requiresTennisAustraliaLinkCheck = ({ event, isGateEnabled, isAuthenticated, flow }) => {
    if (!isAuthenticated || !isGateEnabled || !isAo1PointSlamEvent(event)) {
        return false;
    }
    return !tennisAustraliaGateExemptFlows.includes(flow);
};

export const shouldShowTennisAustraliaLinkSuccessToast = ({ hasPendingLink, hasLinkError, hasLinkedTennisAustraliaAccount }) => {
    return Boolean(hasPendingLink) && !hasLinkError && Boolean(hasLinkedTennisAustraliaAccount);
};

export const shouldResumeAo1PointSlamRegistration = ({ pendingRegistrationEventId, eventId, hasResumed }) => {
    if (!pendingRegistrationEventId || hasResumed) {
        return false;
    }
    return String(pendingRegistrationEventId) === String(eventId ?? '');
};

export const tennisAustraliaLinkErrorMessages = {
    acct_already_linked: 'This Tennis Australia account is already linked to a different UTR account. Sign in with that account, or link a different Tennis Australia account to continue registering.',
    auth_method_error: 'We could not link your Tennis Australia account because of how it signs in. Please try again, and contact Tennis Australia support if the problem continues.',
    access_denied: 'Account linking was cancelled before it finished. You will need a linked Tennis Australia account to register for this event.',
    internal_server_error: 'Something went wrong while linking your Tennis Australia account. Please try again in a moment.',
};

const genericTennisAustraliaLinkErrorMessage = 'We could not link your Tennis Australia account. Please try again.';

export const getTennisAustraliaLinkError = ({ error, errorDescription } = {}) => {
    if (!error) {
        return null;
    }
    return {
        title: 'Tennis Australia account not linked',
        message: tennisAustraliaLinkErrorMessages[error] || errorDescription || genericTennisAustraliaLinkErrorMessage,
    };
};
